import {camelCase} from 'lodash';

export const flattenObject = (obj, prefix = '') =>
  Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? prefix + '.' : '';
    if (typeof obj[k] === 'object') Object.assign(acc, flattenObject(obj[k], pre + k));
    else acc[pre + k] = obj[k];
    return acc;
  }, {});

export const camelCaseObjectKeys = (obj: Record<string, unknown>) =>
  Object.keys(obj).reduce((acc, curr) => {
    const key = camelCase(curr);
    acc[key] = obj[curr];
    return acc;
  }, {} as Record<string, unknown>);

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
